import RepositoryIcon  from '@mui/icons-material/AccountTree';
import RepositoryList from './RepositoryList';
import RepositoryShow from './RepositoryShow';
// import AccessEdit from './AccessEdit';
// import AccessCreate from './AccessCreate';


const repository = {
    list: RepositoryList,
    show: RepositoryShow,
    icon: RepositoryIcon
};

export default repository;